import { PencilSquareIcon, TrashIcon } from "@heroicons/react/20/solid";
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import EditDocument from "./Calender/EditDocument";



export default function DashboardDocumenten({
  attachments,
  user,
  deleteDocument,
  type = 'documenten',
  setRefresh = () => {},
}) {

  const [open, setOpen] = useState(false);
  const [document, setDocument] = useState(null)

  const updateFile = (item) => {
    setDocument(item);
  }

  useEffect(() => {
    if(document){
      setOpen(true);
    }
  }, [document])

  useEffect(() => {
    if(!open)
    setRefresh(true);
  }, [open])

  return (
    <div className="mt-4 rounded-lg border border-wa-border bg-wa-panel p-4 sm:p-6">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-lg font-semibold text-wa-text">
            Documenten (aantal documenten geupload {attachments?.length > 0 ? attachments.length : 0})
          </h1>
          <p className="mt-2 text-sm text-wa-muted">
            Hier vindt u de lijst van alle documenten die u hier heeft geüpload.{" "}
          </p>
        </div>
      </div>
      <div className="mt-6 flow-root">
        <div className="-mx-4 overflow-x-auto sm:mx-0">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden rounded-lg border border-wa-border bg-wa-panel2">
              {attachments?.length > 0 ? (
                <table className="min-w-full divide-y divide-wa-border">
                  <thead className="bg-[#081328]">
                    <tr>
                      {user?.role_id == 2 && type != 'advies' && (
                        <th
                          scope="col"
                          className="relative w-10 py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                          <span className="sr-only">Edit</span>
                        </th>
                      )}
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-wa-text"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-wa-text"
                      >
                        Type
                      </th>
                    
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                          <span className="sr-only">Dowload/Delete</span>
                        </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-wa-border">
                    {attachments.map((document,key) => (
                      <tr key={document?.id || key} className="bg-wa-panel2">
                        {user?.role_id == 2 && type != 'advies' && (
                          <td className="relative whitespace-nowrap w-10 py-4 pl-3 pr-4 text-left text-sm font-medium sm:pr-6">
                            <div
                              onClick={()=>updateFile(document)}
                              className="text-green-500 flex justify-start hover:text-green-400"
                            >
                              <PencilSquareIcon className="h-6 w-6" />
                            </div>
                          </td>
                        )}
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-wa-text">
                          {document?.title ? `${document?.title}:${document?.bestand}`: document?.bestand }
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-wa-text">
                          {document?.type && document?.type.split('/').length > 1? document?.type.split('/')[1]?.toUpperCase():document?.type}
                        </td>
              
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                            <div className="inline-flex">
                            <a
                            href={document?.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-medium flex justify-end text-blue-500 hover:text-blue-400 mr-4"
                          >
                            <DocumentArrowDownIcon className="h-6 w-6" />
                          </a>
                          {user?.role_id == 2 && type != 'advies' && ( <div
                              onClick={()=>deleteDocument(document)}
                                className="text-red-500 flex justify-end hover:text-red-400"
                            >
                              <TrashIcon className="h-6 w-6" />
                            </div>  )}
                            </div>
                          
                          </td>
                      
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="text-center p-8 text-wa-muted">
                  <p>Er zijn geen documenten gevonden.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EditDocument setOpen={setOpen} open={open} attachment={document}/>

    </div>
  );
}
